import { render, staticRenderFns } from "./attributelist.vue?vue&type=template&id=5ee71806&"
import script from "./attributelist.vue?vue&type=script&lang=js&"
export * from "./attributelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports